// import { Navigation, Pagination } from "swiper/modules";
import "slick-carousel";
import $ from "jquery";
const imageSlider = () => {
  const init = () => {
    slider();
  };

  const slider = () => {
    const el = {
      swiper: ".ImageSlider",
    };

    if ($(el.swiper).length === 0) return;

    // * Slick Js
    $(el.swiper).slick({
      dots: true,
      appendDots: $(".mi-image-slider-dots"),
      // arrows: false,
      infinite: true,
      slidesToShow: 1,
      centerMode: true,
      variableWidth: true,
      nextArrow: $(".mi-image-slider-button-next"),
      prevArrow: $(".mi-image-slider-button-prev"),
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  };

  init();
};

try {
  imageSlider();
} catch (e) {
  console.error("Chart Slider : ", e);
}
